import script from "./EmployeeMobileSOPBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeMobileSOPBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeMobileSOPBottomNav.vue?vue&type=style&index=0&id=19e474fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e474fb"]])

export default __exports__